/**
 * Aussehen der Hinweisleiste — einmal, für die Leiste der App (`BannerStrip`)
 * und die Leiste der serverseitigen 404 (`fehlerseite/HinweisLeisteFehlerseite`).
 *
 * Am Telefon steht die Nachricht auf EINER Zeile (Audit P9: die Beta-Leiste
 * nahm 127 px, bevor der eigentliche Inhalt begann); „Mehr" klappt sie auf.
 * Das ist der Weg, den Platz zu sparen — nicht das Wegklicken (Fleet-Kanon
 * „Beta-Hinweis ist immer sichtbar“, 17.10.2026).
 */
export interface StilVorlage {
  bg: string;
  border: string;
  text: string;
  accent: string;
}

export const STIL_VORLAGEN: Record<string, StilVorlage> = {
  info:    { bg: 'var(--blue-100)', border: 'var(--info)', text: 'var(--blue-900)', accent: 'var(--blue-700)' },
  warning: { bg: 'var(--amber-100)', border: 'var(--warning)', text: 'var(--amber-900)', accent: 'var(--amber-600)' },
  success: { bg: 'var(--green-100)', border: 'var(--green-500)', text: 'var(--green-900)', accent: 'var(--green-700)' },
  // Beta trägt das Gold des Logos (Auszeichnung), nicht mehr Lila.
  beta:    { bg: 'var(--gold-bg)', border: 'var(--gold)', text: 'var(--text-primary)', accent: 'var(--text-marke)' },
  danger:  { bg: 'var(--red-100)', border: 'var(--danger)', text: 'var(--red-900)', accent: 'var(--red-700)' },
};

/** Die Vorlage einer Art; eine unbekannte Art ist ein Fehler im Datenbestand und wird laut. */
export function stilVorlage(stil: string): StilVorlage {
  const vorlage = STIL_VORLAGEN[stil];
  if (vorlage === undefined) {
    console.error('Hinweisleiste: unbekannte Art', stil);
    return STIL_VORLAGEN.info;
  }
  return vorlage;
}

export const ZEILE_CSS = `
  .bs-mehr { display: none; }
  @media (max-width: 720px) {
    /* Zugeklappt: alles auf EINER Zeile, der Text wird gekürzt.
       Aufgeklappt: der Text darf umbrechen, die Knöpfe rutschen darunter. */
    .bs-zeile:not(.bs-zeile-offen) { flex-wrap: nowrap !important; }
    .bs-zeile:not(.bs-zeile-offen) .bs-text {
      flex: 1 1 0 !important;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .bs-mehr { display: inline; }
  }
`;

/** Die Pille „BETA“ — ein Abzeichen, kein Satz (in jeder Sprache gleich). */
export const BETA_PILLE = {
  background: 'var(--gold-verlauf)',
  color: 'var(--text-on-gold)',
  fontSize: '1rem',
  fontWeight: 700,
  padding: '2px 8px',
  borderRadius: 'var(--radius-pill)',
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  flexShrink: 0,
} as const;
